import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export function useMazorCodeValidationEffect({
    validateMazorCodeRes,
    screenSwitchOnReviewBtnClick,
    screenSwitchOnUnidInfoBtnClick,
    setFooterButtonStatuses,
    footerButtonStatuses,
    cancel,
    saveAndExit,
}) {
    useEffectWithErrorLogging(() => {
        if (validateMazorCodeRes?.mazorXvalidationClickedBtn) {
            if (validateMazorCodeRes?.statusCode === '10723') {
                if (
                    validateMazorCodeRes?.mazorXvalidationClickedBtn ===
                    'review'
                ) {
                    screenSwitchOnReviewBtnClick();
                } else if (
                    validateMazorCodeRes?.mazorXvalidationClickedBtn ===
                    'unidInfo'
                ) {
                    screenSwitchOnUnidInfoBtnClick();
                }
            } else {
                if (
                    validateMazorCodeRes?.mazorXvalidationClickedBtn ===
                        'review' ||
                    validateMazorCodeRes?.mazorXvalidationClickedBtn ===
                        'unidInfo'
                ) {
                    setFooterButtonStatuses(
                        footerButtonStatuses.map((x) =>
                            x.btnName !== cancel &&
                            x.btnName !== saveAndExit &&
                            x.btnVisibility
                                ? { ...x, isBtnDisable: true }
                                : x
                        )
                    );
                }
            }
        }
    }, [validateMazorCodeRes]);
}